import { GoogleLogo } from "@phosphor-icons/react";

export const GoogleButton = ({ testId }) => {
  const go = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <>
      <div className="my-6 flex items-center gap-3 text-xs text-muted-foreground">
        <span className="flex-1 h-px bg-foreground/10" /> or <span className="flex-1 h-px bg-foreground/10" />
      </div>
      <button
        type="button"
        onClick={go}
        data-testid={testId}
        className="neu-btn w-full inline-flex items-center justify-center gap-2 px-8 py-4 font-medium text-foreground"
      >
        <GoogleLogo size={18} weight="bold" /> Continue with Google
      </button>
    </>
  );
};
